import React, {Component} from 'react';
import Map from "./Map";
import holstein from "../../maps/holstein";
import westholstein from "../../maps/westholstein";
import {GeoJSON} from "react-leaflet";
import L from "leaflet";

const base_maps = {
    'holstein': holstein,
    'westholstein': westholstein,
};

export default class BaseMap extends Component {
    render() {
        const base_map = base_maps[this.props.basemap.trim()];
        let bounds = L.geoJSON(base_map).getBounds();
        let boundsOptions={};
        let center = 0;

        if(this.props.items && this.props.items.length > 1 && this.props.zoom) {
            //Center on items with zoom as maxzoom. MaxZoom does not work
            bounds = this.props.items.map((item) => [item.lat, item.lng]);
            boundsOptions={maxZoom: this.props.zoom}
        }
        if(this.props.items && this.props.items.length == 1 && this.props.zoom) {
            bounds = null;
            center = [this.props.items[0].lat, this.props.items[0].lng]
        }

        return <Map center={center} bounds={bounds} boundsOption={boundsOptions} height={this.props.height} zoom={this.props.zoom}>
            <GeoJSON data={base_map} style={() => ({
                "color": "#000000",
                "fillColor": "#000000",
                "weight": 2,
                "opacity": 0.5,
                "stroke": true,
            })} ref={ref => this.geojson = ref}/>
            {this.props.children}
        </Map>;
    }
}
